import type { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { MfaResponse, MfaResponseType } from '../../../types';
import { AUTHENTICATION_LOG_REASONS } from '@silverfort-nodelibs/common/utils/consts';
import { ChartColors } from '@silverfort/sf-components';

const COLORS: Record<MfaResponseType, string> = {
    true: ChartColors['data-bg-main-1'],
    automatic: ChartColors['data-bg-main-2'],
    'user-excluded': ChartColors['data-bg-main-3'],
    false: ChartColors['data-bg-main-4'],
    'no-relevant_tokens': ChartColors['data-bg-main-5'],
    'cant-send-mfa': ChartColors['data-bg-main-6'],
    timeout: ChartColors['data-bg-main-7'],
    'invalid-token': ChartColors['data-bg-main-8'],
    unpaired: ChartColors['data-bg-main-9'],
    'auto-deny': ChartColors['data-bg-main-10'],
    unprotected: ChartColors['data-bg-main-11'],
    'invalid-otp': ChartColors['data-bg-main-12'],
    'fail-open': ChartColors['data-bg-main-13'],
    'fail-close': ChartColors['data-bg-main-14'],
    'same-group': ChartColors['data-bg-main-15']
};

export const useMfaResponseData = (
    onClick: (mfaResponse: MfaResponseType) => void,
    summary?: MfaResponse
): DonutChartData[] => {
    const filteredSummary = Object.entries(summary ?? {}).filter(([_, value]) => value > 0);

    return filteredSummary.map(([key, value]) => ({
        name: Object.values(AUTHENTICATION_LOG_REASONS).find((reason) => reason.USER_RESPONSE === key)?.DISPLAY ?? '',
        value,
        fill: COLORS[key],
        onClick: () => onClick(key as MfaResponseType),
        tooltipContent: `${
            Object.values(AUTHENTICATION_LOG_REASONS).find((reason) => reason.USER_RESPONSE === key)?.DISPLAY
        }: ${value}`
    }));
};
